// extracted by mini-css-extract-plugin
export default {"size":"LoaderDefaultImage_size__Bs+47","loaderContainer":"LoaderDefaultImage_loaderContainer__Tav5h","floating":"LoaderDefaultImage_floating__n6C2L"};